import * as CategoryActionTypes from '../../constants/category/ActionTypes';
import CategoryTreeHelper from '../../components/category/CategoryTreeHelper';
import update from 'immutability-helper'
import { MAXIMUM_NODE_COUNT } from "../../constants/category/CategoryLimit";

const treeHelper = new CategoryTreeHelper();

function updateCategoryValue(state, id, name, value) {
  let result = update(state, {
    categoryTree: {
      $set: treeHelper.updateValue(state.categoryTree, id, name, value)
    }
  });

  if (id > 0) {
    result = update(result, {
      updatedCategories : {
        $push: [id]
      }
    });
  }
  return result;
}

function makeUpdateQuery(index, categoryInfo, applyImage, applyDescription) {
  let query = {};

  if (index.length < 3) {
    query.categoryInfo = {
      $set: categoryInfo
    };

    let childrenQuery = {
      categoryInfo: {
        liststyle: {
          $set: categoryInfo.liststyle
        }
      }
    };

    if (applyImage) {
      childrenQuery.categoryInfo.image = {
        $set: categoryInfo.image
      };
    }
    if (applyDescription) {
      childrenQuery.categoryInfo.description = {
        $set: categoryInfo.description
      };
    }

    query.children = {
      $apply: (items) => items.map(item =>
        update(item, childrenQuery)
      )
    }
  } else {
    query.children = {
      [index[2]]: {
        categoryInfo: {
          $set: categoryInfo
        }
      }
    };
  }

  return {
    [index[1]]: query
  };
}

function updateCategoryInfo(state, id, categoryInfo, applyImage, applyDescription) {
  let categoryTree = state.categoryTree;
  let index = treeHelper.getIndex(id);

  let updatedIds = [];
  if (id > 0) {
    updatedIds.push(id);
  }
  if (index.length < 3) {
    categoryTree[index[1]].children.forEach(item => {
      if (item.id > 0) {
        updatedIds.push(item.id);
      }
    });
  }

  let result = update(state, {
    categoryTree: makeUpdateQuery(index, categoryInfo, applyImage, applyDescription),
    infoEditCategory: {
      $set: null
    },
    updatedCategories: {
      $push: updatedIds
    }
  });

  treeHelper.rebuildChildren(result.categoryTree);
  return result;
}

const initialState = {
  categoryTree : [],
  categoryInEditMode: [],
  rootCategoryLabel : '분류 전체보기',
  nodeCount : 0,
  initialValue : [],
  viewChannels: [],

  appendedCategories : [], // 추가
  updatedCategories : [], // 라벨 또는 연결 주제 수정한 카테고리들(위치 이동 없이 업데이트 할 시에는 배열에 추가되지 않고 바로 ajax로 업데이트)
  deletedCategories : [], // 삭제

  needBulkUpdateChecker : null,
  infoEditCategory: null
};

export default (state = initialState, action) => {

  const { categoryInEditMode, appendedCategories, rootCategoryLabel } = state;
  let { categoryTree, nodeCount } = state;

  let rootCategory = {
    name: rootCategoryLabel,
    label : rootCategoryLabel,
    id : 0,
    depth : 0,
    children : [],
    priority : 1,
    opened : true,
  };

  switch (action.type) {

    case CategoryActionTypes.UPDATE_CATEGORY_INFO:
      return updateCategoryInfo(state, action.categoryId, action.categoryInfo, action.applyImage, action.applyDescription);

    case CategoryActionTypes.SET_EDITING_CATEGORY_INFO:
      return update(state, {
        infoEditCategory: {
          $set: action.category
        }
      });

    case CategoryActionTypes.INIT_CATEGORY:

      rootCategory.children = action.data.categories;
      treeHelper.init(rootCategory);

      return Object.assign({}, initialState, {
        treeHelper: treeHelper,
        rootCategoryLabel: action.data.rootLabel,
        categoryTree: action.data.categories,
        initialValue: action.data.categories,
        viewChannels: action.data.viewChannels,
        nodeCount : treeHelper.nodeCount,
        needBulkUpdateChecker : {
          rootCategoryLabel : action.data.rootLabel,
          initialIndexPath : JSON.parse(JSON.stringify(treeHelper.indexPath)),
          appendedCategories : [],
          updatedCategories : [],
          deletedCategories : [],
        }
      });

    case CategoryActionTypes.OPEN_ALL_SUB_CATEGORY :

      let allOpenedCategoryTree = treeHelper.openAll(categoryTree);

      return update(state, {
        categoryTree: {
          $set: allOpenedCategoryTree
        }
      });

    case CategoryActionTypes.CLOSE_ALL_SUB_CATEGORY :

      let allClosedCategoryTree = treeHelper.closeAll(categoryTree);

      return update(state, {
        categoryTree: {
          $set: allClosedCategoryTree
        }
      });

    case CategoryActionTypes.OPEN_SUB_CATEGORY:

      let openedOneCategoryTree = treeHelper.openCategory(categoryTree, action.index);

      return update(state, {
        categoryTree: {
          $set: openedOneCategoryTree
        }
      });

    case CategoryActionTypes.CLOSE_SUB_CATEGORY:

      let closedOneCategoryTree = treeHelper.closeCategory(categoryTree, action.index);

      return update(state, {
        categoryTree: {
          $set: closedOneCategoryTree
        }
      });

    case CategoryActionTypes.MOVE_CATEGORY :

      let movedCategoryTree = treeHelper.move(categoryTree, action.category, action.to, action.placement);

      return update(state, {
        categoryTree: {
          $set: movedCategoryTree
        }
      });

    case CategoryActionTypes.UPDATE_CATEGORY_NAME:
      return updateCategoryValue(state, action.categoryId, 'name', action.name);

    case CategoryActionTypes.UPDATE_CATEGORY_VIEW_CHANNEL :
      return updateCategoryValue(state, action.categoryId, 'viewChannel', action.viewChannel);

    case CategoryActionTypes.START_EDIT_MODE:

      // 카테고리의 수정은 추가된 카테고리(임시로 id 가 음수로 지정된 노드들)을 제외하고
      // 한번에 하나의 카테고리만을 수정할 수 있다.

      const alreadyExist = categoryInEditMode.filter((item) => (item === action.categoryId)).length !== 0;

      if (alreadyExist) {
        return state;
      } else {

        let oldNodeIndex = categoryInEditMode.findIndex((item) => (item > 0));

        if (oldNodeIndex !== -1) {
          return update(state, {
            categoryInEditMode: {
              $splice: [[oldNodeIndex, 1, action.categoryId]],
            }
          });
        } else {
          return update(state, {
            categoryInEditMode: {
              $push: [action.categoryId]
            }
          });
        }
      }

    case CategoryActionTypes.END_EDIT_MODE:
      return update(state, {
        categoryInEditMode: {
          $set: categoryInEditMode.filter((item) => (item !== action.categoryId))
        }
      });

    case CategoryActionTypes.APPEND_CATEGORY:

      if (nodeCount >= MAXIMUM_NODE_COUNT) {
        alert('카테고리는 '+MAXIMUM_NODE_COUNT+'개까지 만들 수 있습니다. 카테고리를 재조정해보세요.');
        return state;
      }

      const newCategoryForAppend = treeHelper.makeNew(action.category);

      const appendedCategoryTree = treeHelper.append(categoryTree, newCategoryForAppend, action.category.id);

      return update(state, {
        categoryTree: {
          $set: appendedCategoryTree
        },
        appendedCategories: {
          $push: [newCategoryForAppend.id]
        },
        categoryInEditMode: {
          $push: [newCategoryForAppend.id]
        },
        nodeCount : {
          $set : nodeCount + 1
        }
      });

    case CategoryActionTypes.PREPEND_AT_ROOT_CATEGORY :

      if (nodeCount >= MAXIMUM_NODE_COUNT) {
        alert('카테고리는 '+MAXIMUM_NODE_COUNT+'개까지 만들 수 있습니다. 카테고리를 재조정해보세요');
        return state;
      }

      const newCategoryForPrepend = treeHelper.makeNew(rootCategory);
      const prependedCategoryTree = treeHelper.prependRoot(categoryTree, newCategoryForPrepend);

      return update(state, {
        categoryTree: {
          $set: prependedCategoryTree
        },
        appendedCategories: {
          $push: [newCategoryForPrepend.id]
        },
        categoryInEditMode: {
          $push: [newCategoryForPrepend.id]
        },
        nodeCount : {
          $set : nodeCount + 1
        }
      });

    case CategoryActionTypes.APPEND_AT_ROOT_CATEGORY :

      if (nodeCount >= MAXIMUM_NODE_COUNT) {
        alert('카테고리는 '+MAXIMUM_NODE_COUNT+'개까지 만들 수 있습니다. 카테고리를 재조정해보세요');
        return state;
      }

      const newCategoryForAppendAtRoot = treeHelper.makeNew(rootCategory);
      const appendedCategoryTreeForRoot = treeHelper.appendRoot(categoryTree, newCategoryForAppendAtRoot);

      return update(state, {
        categoryTree: {
          $set: appendedCategoryTreeForRoot
        },
        appendedCategories: {
          $push: [newCategoryForAppendAtRoot.id]
        },
        categoryInEditMode: {
          $push: [newCategoryForAppendAtRoot.id]
        },
        nodeCount : {
          $set : nodeCount + 1
        }
      });

    case CategoryActionTypes.REMOVE_CATEGORY:

      const removedCategoryTree = treeHelper.remove(categoryTree, action.categoryId);

      // 현재 화면상에서 새롭게 추가했다가 삭제한 카테고리라면
      // category tree 에서만 삭제.
      if (action.categoryId < 0){

        const filteredAppendedCategoryTree = appendedCategories.filter((item => (item !== action.categoryId)));

        return update(state, {
          categoryTree: {
            $set: removedCategoryTree
          },
          appendedCategories : {
            $set : filteredAppendedCategoryTree
          },
          categoryInEditMode: {
            $set: categoryInEditMode.filter((item) => (item !== action.categoryId))
          },
          nodeCount : {
            $set : nodeCount - 1
          }
        });
      }else{
        // category tree 에서 삭제하고,
        // 삭제된 카테고리 리스트에 추가하여
        // 전체 저장시 적용되게 함
        return update(state, {
          categoryTree : {
            $set : removedCategoryTree
          },
          deletedCategories : {
            $push : [action.categoryId]
          },
          nodeCount : {
            $set : nodeCount - 1
          }
        });
      }

    case CategoryActionTypes.UPDATE_ROOT_CATEGORY_LABEL:

      return update(state, {
        rootCategoryLabel : {
          $set : action.rootLabel
        }
      });

    case CategoryActionTypes.UPDATE_CATEGORY_TREE :

      const rebuildCategoryTree = treeHelper.rebuildNodes(action.categoryTree);
      const newNodeCount = treeHelper.nodeCount;

      return update(state, {
        categoryTree : {
          $set : rebuildCategoryTree
        },
        nodeCount : {
          $set : newNodeCount
        },
        appendedCategories : {
          $set : []
        },
        updatedCategories : {
          $set : []
        },
        deletedCategories : {
          $set : []
        },
        needBulkUpdateChecker : {
          $set : {
            rootCategoryLabel : rootCategoryLabel,
            initialIndexPath : JSON.parse(JSON.stringify(treeHelper.indexPath)),
            appendedCategories : [],
            updatedCategories : [],
            deletedCategories : [],
          }
        }

      });

    case CategoryActionTypes.UPDATE_CATEGORY_VISIBILITY:
      console.log(action.categoryId, 'visibility', action.visibility);
      return updateCategoryValue(state, action.categoryId, 'visibility', action.visibility);

    default:
      return state;
  }
}
